import React, { FC, useState } from "react"
import ReactDOM from "react-dom"
import { RegularButton } from "@components/button"
import clsx from "clsx"
import { MdSort } from "react-icons/md"
import { CategoryRow } from "./CategoryRow"
import { Category } from "@interfaces/category"

type PopUpState = "none" | "modal" | "bottom-bar"

interface CategoryMobileProps {
  screenWidth: number
  activeCategory: string
  setActiveCategory: (val: string) => void
  duration: string
  setDuration: (val: string) => void
  categories: Category[]
}

interface BottomShareProps {
  open: boolean
  onClose: () => void
  children: any
}

const BottomShare = ({ open, onClose, children }: BottomShareProps) => {
  if (!open) {
    return <></>
  }

  return ReactDOM.createPortal(
    <div className="top-0 left-0 fixed w-full h-full z-[100]">
      {/*  Overlay for mobile view */}
      <div onClick={onClose} className="fixed w-full h-full bg-backdrop z-[100]" />
      {children}
    </div>,
    document.body
  )
}

export const CategoryMobile: FC<CategoryMobileProps> = ({
  categories,
  activeCategory,
  setActiveCategory,
  setDuration,
  duration,
  screenWidth,
}) => {
  const [popUpState, setPopUpState] = useState<PopUpState>("none")

  const handleOpen = async () => {
    setPopUpState("bottom-bar")
  }

  const handleHideModal = () => {
    setPopUpState("none")
  }

  return (
    <>
      <RegularButton
        className={clsx(
          "flex items-center justify-center gap-3 sm:text-green font-semibold",
          " sm:hidden h-full"
        )}
        onClick={handleOpen}
        // variant="transparent"
      >
        <MdSort className="h-full" size={22} />
      </RegularButton>

      <BottomShare open={popUpState === "bottom-bar"} onClose={handleHideModal}>
        <div
          className={clsx(
            "z-[200] w-full fixed bottom-0 left-0 bg-white rounded-t-[20px] transition-all",
            popUpState === "bottom-bar" ? " py-2.5 px-5" : "max-h-0"
          )}
        >
          <CategoryRow
            categories={categories}
            screenWidth={screenWidth}
            activeCategory={activeCategory}
            setActiveCategory={setActiveCategory}
            duration={duration}
            setDuration={setDuration}
            onClose={handleHideModal}
          />
        </div>
      </BottomShare>
    </>
  )
}
